import { useMutation, useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { keys } from "@/data/keys";

type BurgerPatch = Partial<{
  description: string | null;
  canonical_image_url: string | null;
  canonical_patty_type: string | null;
  canonical_cooking_level: string | null;
  canonical_is_smashed: boolean | null;
  canonical_patty_amount: number | null;
  canonical_toppings: string[] | null;
  canonical_cheese: string[] | null;
  canonical_sauces: string[] | null;
  canonical_bun_type: string | null;
}>;

/**
 * Update a burger row. Caller is responsible for RLS — only the
 * burger's creator can update via the active policy.
 */
export function useUpdateBurger() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({ id, patch }: { id: string; patch: BurgerPatch }) => {
      const { error } = await supabase.from("burgers").update(patch).eq("id", id);
      if (error) throw error;
      return { id, patch };
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: keys.burgers.all });
    },
  });
}
